export default __webpack_public_path__ + "static/media/icon-coin-near.9cd2c091.svg";